<template name="dialog-confirm">
	<div class="close-confirm-dialog">
		<!-- 确认关闭活动 -->
		<el-dialog
		  title="强制结束"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<p class="tip">
				强制结束操作需谨慎，确定要强制结束吗？
			</p>
			<div slot="footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="confirm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		close
	} from '@/api/event';
	export default {
		data() {
			return {
				
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			event_id: {
				type: Number,
				default: 0,
			},
		},
		methods: {
			close() {
				this.$emit('close');
			},
			confirm() {
				close({
					event_id: this.event_id,
				}).then(res => {
					if (res.code == 0) {
						this.$message.success(res.message);
						this.$emit('success');
					} else {
						this.$message.error(res.message);
					}
				})
			}
		},
		mounted() {
			
		}
	}
</script>

<style scoped>
	.close-confirm-dialog .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}
	.close-confirm-dialog .el-dialog {
		width: 424px;
	}
	.close-confirm-dialog .tip {
		padding: 10px 20px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
	}
	.close-confirm-dialog .el-dialog__footer {
		padding-top: 0;
		padding-bottom: 16px;
	}
</style>
